export const areaCities = ['гр. София', 'гр. Пловдив', 'гр. Варна'];
